<mat-dialog-content>
  <div class="w-100">

    <div class="fs-4 text-black mb-4 fw-bold">Please Enter No of Pax:</div>

    <div class="row">
      <div class="col-md-12 d-flex flex-column">
        <div class="fs-3 fw-bold">
          <input type="number"
                 class="p-2 px-3 rounded w-100"
                 style="border: 1px solid var(--bs-border-color)"
                 tabindex="-1" [(ngModel)]="paxNo">
        </div>
      </div>

    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="d-flex justify-content-center w-100 p-3">
    <div class="col-4 me-3">
      <button class="btn btn-default border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Cancel</span>
      </button>
    </div>
    <div class="col-8" role="button" (click)="submit()">
      <button
        class="btn btn-default bg-primary text-white w-100 h-100 d-flex align-items-center justify-content-center">
        <i class="fa fa-check-circle me-2"></i>
        <span>Apply</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
